'use client';

import { Trait } from '@baseball-near-you/common';
import { DropdownMenuSelect } from './DropdownMenuSelect';

export function TraitSelect(props: {
  onSelect: (val: string) => void;
  val: string;
}) {
  return (
    <DropdownMenuSelect
      onSelect={props.onSelect}
      val={props.val}
      values={Object.values(Trait)}
      defaultLabel="Select a trait"
    />
  );
}
